export const prefilledInputComponentStyling = {
  borderColor: '#FFBC0F',
  backgroundColor: '#FFF9EA',
};
